<template>
  <div>
    <a-row
      type="flex"
      justify="space-around"
      :gutter="[48, 16]"
      style="text-align: left"
    >
      <a-col :span="12">
        <h2>{{ $t("Invoice processing") }}</h2>
        <!-- <h3>
          <a-checkbox
            @change="(e) => handleChangeInvoiceProcessingCheckbox(e, 'one')"
            >{{
              $t(
                "In repeated (recursive) invoices, we only confirm the first invoice"
              )
            }}</a-checkbox
          >
        </h3>
        <h2>{{ $t("Responsible people by default") }}</h2> -->
        <a-col :span="24">
          <h3>{{$t('Odpowiedzialny za rozksięgowanie')}}</h3>
          <a-select
            show-search
            mode="multiple"
            style="margin-bottom: 15px; width: 100%"
            option-filter-prop="children"
            :default-value="defaultResponsible.processing || []"
            :filter-option="filterOption"
            @change="
              (e) => handleChangeDefaultResponsibleSelect({ processing: e })
            "
          >
            <a-select-option
              v-for="(name, id) in usernameList"
              :key="id"
            >{{
              name
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24">
          <h3>{{ $t("Responsible for verifications") }}</h3>
          <a-select
            show-search
            mode="multiple"
            style="margin-bottom: 15px; width: 100%"
            option-filter-prop="children"
            :default-value="defaultResponsible.verification || []"
            :filter-option="filterOption"
            @change="
              (e) => handleChangeDefaultResponsibleSelect({ verification: e })
            "
          >
            <a-select-option
              v-for="(name, id) in usernameList"
              :key="id"
            >{{
              name
            }}</a-select-option>
          </a-select>
        </a-col>
      </a-col>
      <a-col :span="12">
        <h2>{{$t('Faktury sprzedaży')}}</h2>
        <a-col :span="24">
          <h3>{{ $t("Reading") }}</h3>
          <a-select
            show-search
            mode="multiple"
            style="margin-bottom: 15px; width: 100%"
            option-filter-prop="children"
            :default-value="responsibleFVS.responsibleRead"
            :filter-option="filterOption"
            @change="(e) => handleChangeRightsFVS({ responsibleRead: e })"
          >
            <a-select-option
              v-for="(name, id) in usernameList"
              :key="id"
            >{{
              name
            }}</a-select-option>
          </a-select>
        </a-col>

        <a-col :span="24">
          <h3>{{ $t("Read and create") }}</h3>
          <a-select
            show-search
            mode="multiple"
            style="margin-bottom: 15px; width: 100%"
            option-filter-prop="children"
            :default-value="responsibleFVS.responsibleSpredz"
            :filter-option="filterOption"
            @change="(e) => handleChangeRightsFVS({ responsibleSpredz: e })"
          >
            <a-select-option
              v-for="(name, id) in usernameList"
              :key="id"
            >{{
              name
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24">
          <h3>{{ $t("Administrator") }}</h3>
          <a-select
            show-search
            mode="multiple"
            style="margin-bottom: 15px; width: 100%"
            option-filter-prop="children"
            :default-value="responsibleFVS.responsibleAll"
            :filter-option="filterOption"
            @change="(e) => handleChangeRightsFVS({ responsibleAll: e })"
          >
            <a-select-option
              v-for="(name, id) in usernameList"
              :key="id"
            >{{
              name
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24">
          <h3>{{ $t("Office") }}</h3>
          <a-select
            show-search
            mode="multiple"
            style="margin-bottom: 15px; width: 100%"
            option-filter-prop="children"
            :default-value="responsibleFVS.responsibleOffice"
            :filter-option="filterOption"
            @change="(e) => handleChangeRightsFVS({ responsibleOffice: e })"
          >
            <a-select-option
              v-for="(name, id) in usernameList"
              :key="id"
            >{{
              name
            }}</a-select-option>
          </a-select>
        </a-col>
      </a-col>
    </a-row>
    <a-table
      :columns="columnsAccessMatrix"
      :data-source="dataAccessMatrix"
      bordered
      :pagination="{ hideOnSinglePage: true }"
      @expand="resize"
    >
      <template
        v-for="col in [
          'responsible',
          'processing',
          'processingInvoice',
          'verificationsInvoice',
        ]"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-select
            v-if="record.editable"
            show-search
            mode="multiple"
            style="margin: -5px 0; width: 100%"
            :default-value="record[col] || []"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="(e) => handleChangeFieldTable(e, record.key, col)"
          >
            <a-select-option
              v-for="(name, id) in usernameList"
              :key="id"
            >{{
              name
            }}</a-select-option>
          </a-select>
          <template v-else>
            <a-tag
              v-for="val in text"
              :key="val"
              color="#2C7FE4"
            >{{
              usernameList[val]
            }}</a-tag>
          </template>
        </div>
      </template>
      <template
        slot="confidential"
        slot-scope="text, record"
      >
        <a-row>
          <a-col :span="18">
            <a-select
              v-if="record.editable"
              show-search
              mode="multiple"
              style="margin: -5px 0; width: 100%; padding-right: 10px"
              :default-value="record['projectAssistant'] || []"
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="
                (e) => handleChangeFieldTable(e, record.key, 'projectAssistant')
              "
            >
              <a-select-option
                v-for="(name, id) in usernameList"
                :key="id"
              >{{
                name
              }}</a-select-option>
            </a-select>
            <template v-else>
              <!-- {{ usernameList[record['projectAssistant']] }} -->
              <a-tag
                v-for="val in record['projectAssistant']"
                :key="val"
                color="#2C7FE4"
              >{{ usernameList[val] }}</a-tag>
            </template>
          </a-col>
          <a-col :span="6">
            <a-tooltip>
              <template slot="title">Uzyskaj dostęp do poufnych plików</template>
              <a-switch
                v-if="record.editable"
                :default-checked="text"
                @change="
                  (e) => handleChangeFieldTable(e, record.key, 'confidential')
                "
              >
                <a-icon
                  slot="checkedChildren"
                  type="check"
                />
                <a-icon
                  slot="unCheckedChildren"
                  type="close"
                />
              </a-switch>
              <template v-else-if="text">
                <a-icon
                  type="check-circle"
                  theme="twoTone"
                  two-tone-color="#52c41a"
                />
              </template>
              <template v-else>
                <a-icon
                  type="close-circle"
                  theme="twoTone"
                  two-tone-color="#eb2f96"
                />
              </template>
            </a-tooltip>
          </a-col>
        </a-row>
      </template>
      <template
        slot="operation"
        slot-scope="text, record"
      >
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="() => handleSaveField(record.key)">
              <a-icon type="save" />
            </a>
            <a @click="() => handleCancelField(record.key)">
              <a-icon type="close" />
            </a>
          </span>
          <span v-else>
            <a
              :disabled="editingKey !== ''"
              @click="() => handleEditField(record.key)"
            >
              <a-icon type="edit" />
            </a>
          </span>
        </div>
      </template>

      <template
        slot="expandedRowRender"
        slot-scope="text"
      >
        <a-table
          v-if="text.editable"
          :columns="innerMPKColumns"
          :data-source="text.mpkListData"
          :pagination="false"
        >
          <template
            v-for="innerCol in ['processing', 'verifications', 'budgets']"
            :slot="innerCol"
            slot-scope="text, record"
          >
            <div :key="innerCol">
              <a-select
                show-search
                mode="multiple"
                style="margin: -5px 0; width: 100%"
                :default-value="record[innerCol]"
                option-filter-prop="children"
                :filter-option="filterOption"
                @change="(e) => handleChangeFieldTable(e,record.key,innerCol,record.innerKey)"
              >
                <a-select-option
                  v-for="(name, id) in usernameList"
                  :key="id"
                >{{
                  name
                }}</a-select-option>
              </a-select>
            </div>
          </template>
        </a-table>
        <a-table
          v-else
          :columns="innerMPKColumns"
          :data-source="text.mpkListData"
          :pagination="false"
        >
          <template
            slot="verifications"
            slot-scope="text"
          >
            <a-tag
              v-for="val in text"
              :key="val"
              color="#2C7FE4"
            >{{
              usernameList[val]
            }}</a-tag>
          </template>
        </a-table>
      </template>
    </a-table>
    <RightsToInvoiceFunnel
      v-if="Object.keys(SECTION_LIST).length"
      :usernameList="usernameList"
      :SECTION_LIST="SECTION_LIST"
      :rightsToInvoiceFunnel="rightsToInvoiceFunnel"
    />
  </div>
</template>
<script>
import {
  saveAccessMatrix,
  saveDefaultResponsible,
  saveRightsFVSResponsible,
} from "@/requestFunc";
import RightsToInvoiceFunnel from "@/components/settingsRightsToInvoiceFunnel";
export default {
  components: {
    RightsToInvoiceFunnel,
  },
  props: [
    "myCompany",
    "accessMatrix",
    "usernameList",
    "costCenter",
    "defaultResponsible",
    "responsibleFVS",
    "rightsToInvoiceFunnel",
  ],
  data() {
    return {
      dataAccessMatrix: [],
      cacheAccessMatrixData: [],
      SECTION_LIST: {},
      columnsAccessMatrix: [
        {
          title: this.$t("Nazwa firmy"),
          align: "center",
          dataIndex: "companyName",
        },
        {
          title: this.$t("Rejestrator"),
          align: "center",
          dataIndex: "processing",
          scopedSlots: { customRender: "processing" },
        },
        {
          title: this.$t("Odpowiedzialny za rozksięgowanie"),
          align: "center",
          dataIndex: "confidential",
          scopedSlots: { customRender: "confidential" },
        },
        {
          title: this.$t("Responsible for verifications"),
          align: "center",
          dataIndex: "responsible",
          scopedSlots: { customRender: "responsible" },
        },
        {
          title: this.$t("Actions"),
          align: "center",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      editingKey: "",
      innerMPKColumns: [
        {
          title: this.$t("MPK"),
          dataIndex: "MPK",
          customRender: (text) =>
            text.map((mpk) => <a-tag color="blue">{mpk}</a-tag>),
        },
        {
          title: this.$t("Responsible for verifications"),
          dataIndex: "verifications",
          scopedSlots: { customRender: "verifications" },
        },
      ],
    };
  },
  methods: {
    handleChangeInvoiceProcessingCheckbox() {

    },
    async handleChangeRightsFVS(params) {

      let resp_saveRightsFVSResponsible = await saveRightsFVSResponsible(
        params
      );
      if (resp_saveRightsFVSResponsible.ok) {
        let vals = await resp_saveRightsFVSResponsible.json();
        if (vals == "success") {
          this.$message.success(
            `${ this.$t("Responsible for")} ${Object.keys(params)[0]} ${ this.$t("saved!") }`
          );
        } else {
          this.$message.error(
            `${ this.$t("Error while saving default") } ${Object.keys(params)[0]}`
          );
        }
      } else {
        alert("Ошибка HTTP: " + resp_saveRightsFVSResponsible.status);
      }
    },
    async handleChangeDefaultResponsibleSelect(params) {
  
      let resp_saveDefaultResponsible = await saveDefaultResponsible(params);
      if (resp_saveDefaultResponsible.ok) {
        let vals = await resp_saveDefaultResponsible.json();
        if (vals == "success") {
          this.$message.success(
            `${ this.$t("Responsible for")} ${Object.keys(params)[0]} ${ this.$t("saved!") }`
          );
        } else {
          this.$message.error(
            `${ this.$t("Error while saving default") } ${Object.keys(params)[0]}`
          );
        }
      } else {
        alert("Ошибка HTTP: " + resp_saveDefaultResponsible.status);
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeFieldTable(value, key, column, innerKey) {

      const newData = [...this.dataAccessMatrix];
      const target = innerKey
        ? newData[key]["mpkListData"].filter(
            (item) => innerKey === item.innerKey
          )[0]
        : newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.dataAccessMatrix = newData;
      }
    },
    handleEditField(key) {
      const newData = [...this.dataAccessMatrix];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.dataAccessMatrix = newData;
      }
    },
    handleSaveField(key) {
      const newData = [...this.dataAccessMatrix];
      const newCacheData = [...this.cacheAccessMatrixData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];


      if (target && targetCache) {
        delete target.editable;
        this.dataAccessMatrix = newData;
        Object.assign(targetCache, target);
        this.cacheAccessMatrixData = newCacheData;

        saveAccessMatrix(target)
          .done(() => {
            this.$message.success(this.$t("Access have been saved!"));
          })
          .fail((e) => {
            console.error(e);
            this.$message.error(this.$t("Error"));
          });
      }
      this.editingKey = "";
    },
    handleCancelField(key) {
      const newData = [...this.dataAccessMatrix];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheAccessMatrixData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.dataAccessMatrix = newData;
      }
    },
    onSearchByCompany(value) {
      if (value) {
        for (let i in this.dataAccessMatrix) {
          if (
            this.dataAccessMatrix[i].companyName
              .toLowerCase()
              .indexOf(value.toLowerCase()) != -1
          ) {
            this.dataAccessMatrix[i]["show"] = false;
          }
        }
      } else {
        for (let i in this.dataAccessMatrix) {
          this.dataAccessMatrix[i]["show"] = true;
        }
      }
    },
    getSections() {
      BX24.callMethod(
        "crm.dealcategory.list",
        {
          order: { SORT: "ASC" },
          select: ["ID", "NAME"],
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            let sections = result.data();
            for (let i of sections) {
              this.SECTION_LIST[i.ID] = i.NAME;
            }
            if (result.more()) result.next();
          }
        }
      );
    },
    resize(exrows) {
      if (exrows) {
        BX24.fitWindow();
      } else {
        BX24.resizeWindow(
          parseInt($("body #root_block").css("width")),
          parseInt($("body #root_block").css("height"))
        );
      }
    },
  },
  mounted() {

    this.getSections();

    for (let i in this.myCompany) {

      let mpkList = [];
      let MPK_CostTypes = this.costCenter[this.myCompany[i]["ID"]]

        ? this.costCenter[this.myCompany[i]["ID"]]["MPK_CostTypes"]
        : [];

      if (this.accessMatrix && this.accessMatrix[this.myCompany[i]["ID"]]) {

        for (let j in MPK_CostTypes) {

          if (this.accessMatrix[this.myCompany[i]["ID"]]["ACCESS"]) {

            let index = this.accessMatrix[this.myCompany[i]["ID"]][
              "ACCESS"
            ].findIndex(
              (x) => x?.["MPK"]?.toString() == MPK_CostTypes?.[j]?.["MPK"]?.toString()
            );

            if (index == -1) {
              mpkList.push({
                key: i,
                innerKey: j,
                MPK: MPK_CostTypes[j]["MPK"],
                budgets: "",
                verifications: [],
                processing: "",
              });
            } else {
              mpkList.push({
                key: i,
                innerKey: j,
                ...this.accessMatrix[this.myCompany[i]["ID"]]["ACCESS"][index],
              });
            }
          } else {
            mpkList.push({
              key: i,
              innerKey: j,
              MPK: MPK_CostTypes[j]["MPK"],
              budgets: "",
              verifications: [],
              processing: "",
            });
          }
        }
        this.dataAccessMatrix.push({
          key: i,
          companyName: this.myCompany[i]["TITLE"],
          companyID: this.myCompany[i]["ID"],
          responsible: this.accessMatrix[this.myCompany[i]["ID"]]["HUBLIDER"],
          projectAssistant: this.accessMatrix[this.myCompany[i]["ID"]][
            "ASSISTANT"
          ],
          confidential:
            this.accessMatrix[this.myCompany[i]["ID"]]["RIGHT"] == "true",
          processingInvoice: this.accessMatrix[this.myCompany[i]["ID"]][
            "processingInvoice"
          ],
          verificationsInvoice: this.accessMatrix[this.myCompany[i]["ID"]][
            "verificationsInvoice"
          ],
          processing: this.accessMatrix[this.myCompany[i]["ID"]]["PROCESSING"],
          mpkListData: mpkList,
        });
      } else {
        for (let j in MPK_CostTypes) {
          mpkList.push({
            key: i,
            innerKey: j,
            MPK: MPK_CostTypes[j]["MPK"],
            budgets: "",
            verifications: [],
            processing: "",
          });
        }
        this.dataAccessMatrix.push({
          key: i,
          companyName: this.myCompany[i]["TITLE"],
          companyID: this.myCompany[i]["ID"],
          responsible: "",
          projectAssistant: "",
          confidential: false,
          processing: "",
          mpkListData: mpkList,
        });
      }
    }
    this.cacheAccessMatrixData = this.dataAccessMatrix.map((item) => ({
      ...item,
    }));
    this.resize();
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>